import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventListQueryVariables = Types.Exact<{
  input: Types.GetEventListInput;
}>;

export type GetEventListQuery = {
  __typename?: 'Query';
  getEventList: {
    __typename?: 'GetEventListResponse';
    items: Array<{
      __typename?: 'GetEventListResponseEvent';
      category: string;
      classification: string;
      createdAt: string;
      expectedParticipantsNumber?: number | null;
      incidentNumber?: number | null;
      name: string;
      startDate: string;
      endDate: string;
      updatedAt: string;
      uuid: string;
      timezone: string;
      status: {
        __typename?: 'GetEventListResponseEventStatus';
        name: string;
        uuid: string;
      };
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetEventListDocument = gql`
  query GetEventList($input: GetEventListInput!) {
    getEventList(input: $input) {
      items {
        category
        classification
        createdAt
        expectedParticipantsNumber
        incidentNumber
        name
        startDate
        endDate
        status {
          name
          uuid
        }
        updatedAt
        uuid
        timezone
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetEventListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEventListQuery,
    GetEventListQueryVariables
  > &
    (
      | { variables: GetEventListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventListQuery, GetEventListQueryVariables>(
    GetEventListDocument,
    options,
  );
}
export function useGetEventListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventListQuery,
    GetEventListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventListQuery, GetEventListQueryVariables>(
    GetEventListDocument,
    options,
  );
}
export function useGetEventListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventListQuery,
        GetEventListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventListQuery, GetEventListQueryVariables>(
    GetEventListDocument,
    options,
  );
}
export type GetEventListQueryHookResult = ReturnType<
  typeof useGetEventListQuery
>;
export type GetEventListLazyQueryHookResult = ReturnType<
  typeof useGetEventListLazyQuery
>;
export type GetEventListSuspenseQueryHookResult = ReturnType<
  typeof useGetEventListSuspenseQuery
>;
export type GetEventListQueryResult = Apollo.QueryResult<
  GetEventListQuery,
  GetEventListQueryVariables
>;
export function refetchGetEventListQuery(
  variables: GetEventListQueryVariables,
) {
  return { query: GetEventListDocument, variables: variables };
}
